const accountUserToastMsg = {
  /**
   *  [유저] 유저 리스트 요청하기
   */
  GET_USER_LIST_REQUEST_SUCCESS: '유저 리스트 요청하기 성공',
  GET_USER_LIST_REQUEST_ERROR: '유저 리스트 요청하기 실패',

  /**
   *  [유저] 유저 엑셀 다운로드 요청하기
   */
  GET_USER_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '유저 리스트 엑셀 다운로드 요청하기 성공',
  GET_USER_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '유저 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [유저] 유저 랭킹 리스트 요청하기
   */
  GET_USER_RANK_LIST_REQUEST_SUCCESS: '유저 랭킹 리스트 요청하기 성공',
  GET_USER_RANK_LIST_REQUEST_ERROR: '유저 랭킹 리스트 요청하기 실패',

  /**
   *  [유저] 유저 랭킹 엑셀 다운로드 요청하기
   */
  GET_USER_RANK_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '유저 랭킹 엑셀 다운로드 요청하기 성공',
  GET_USER_RANK_EXCEL_DOWNLOAD_REQUEST_ERROR: '유저 랭킹 엑셀 다운로드 요청하기 실패',

  /**
   *  [유저] 유저 상세정보 요청하기
   */
  GET_USER_DETAIL_REQUEST_SUCCESS: '유저 상세정보 요청하기 성공',
  GET_USER_DETAIL_REQUEST_ERROR: '유저 상세정보 요청하기 실패',

  /**
   *  [유저] 유저 상세 주문 정보 요청하기
   */
  GET_USER_ORDER_DETAIL_REQUEST_SUCCESS: '유저 상세 주문 정보 요청하기 성공',
  GET_USER_ORDER_DETAIL_REQUEST_ERROR: '유저 상세 주문 정보 요청하기 실패',

  /**
   *  [유저] 유저 상세 쿠폰 정보 요청하기
   */
  GET_USER_COUPON_DETAIL_REQUEST_SUCCESS: '유저 상세 쿠폰 정보 요청하기 성공',
  GET_USER_COUPON_DETAIL_REQUEST_ERROR: '유저 상세 쿠폰 정보 요청하기 실패',

  /**
   *  [유저] 유저 상세 포인트 정보 요청하기
   */
  GET_USER_POINT_DETAIL_REQUEST_SUCCESS: '유저 상세 포인트 정보 요청하기 성공',
  GET_USER_POINT_DETAIL_REQUEST_ERROR: '유저 상세 포인트 정보 요청하기 실패',

  /**
   * [유저] 유저 상세 장바구니 정보 요청하기
   */
  GET_USER_CART_DETAIL_REQUEST_SUCCESS: ' 유저 상세 장바구니 정보 요청하기 성공',
  GET_USER_CART_DETAIL_REQUEST_ERROR: ' 유저 상세 장바구니 정보 요청하기 실패',

  /**
   * [유저] 유저 상세 1:1 문의 내역 정보 요청하기
   */
  GET_USER_CS_INQUIRY_DETAIL_REQUEST_SUCCESS: '유저 상세 1:1 문의 내역 정보 요청하기 성공',
  GET_USER_CS_INQUIRY_DETAIL_REQUEST_ERROR: '유저 상세 1:1 문의 내역 정보 요청하기 실패',

  /**
   * [유저] 유저 상세 상품 문의 내역 정보 요청하기
   */
  GET_USER_CS_QNA_DETAIL_REQUEST_SUCCESS: '유저 상세 상품 문의 내역 정보 요청하기 성공',
  GET_USER_CS_QNA_DETAIL_REQUEST_ERROR: '유저 상세 상품 문의 내역 정보 요청하기 실패',

  /**
   * [유저] 유저 상세 상품 후기 정보 요청하기
   */
  GET_USER_CS_REVIEW_DETAIL_REQUEST_SUCCESS: '유저 상세 상품 후기 정보 요청하기 성공',
  GET_USER_CS_REVIEW_DETAIL_REQUEST_ERROR: '유저 상세 상품 후기 정보 요청하기 실패',

  /**
   * [유저] 유저 상세 팔로우한 태그 정보 요청하기
   */
  GET_USER_TAG_DETAIL_REQUEST_SUCCESS: '유저 상세 팔로우한 태그 정보 요청하기 성공',
  GET_USER_TAG_DETAIL_REQUEST_ERROR: '유저 상세 팔로우한 태그 정보 요청하기 실패',

  /**
   * [유저] 유저 상세 좋아요한 상품 정보 요청하기
   */
  GET_USER_LIKE_PRODUCT_DETAIL_REQUEST_SUCCESS: '유저 상세 좋아요한 상품 정보 요청하기 성공',
  GET_USER_LIKE_PRODUCT_DETAIL_REQUEST_ERROR: '유저 상세 좋아요한 상품 정보 요청하기 실패',

  /**
   * [유저] 유저 상세 좋아요한 브랜드 정보 요청하기
   */
  GET_USER_LIKE_BRAND_DETAIL_REQUEST_SUCCESS: '유저 상세 좋아요한 브랜드 정보 요청하기 성공',
  GET_USER_LIKE_BRAND_DETAIL_REQUEST_ERROR: '유저 상세 좋아요한 브랜드 정보 요청하기 실패',

  /**
   * [유저] 장바구니 리스트 요청하기
   */
  GET_USER_DETAIL_CART_LIST_REQUEST_SUCCESS: '장바구니 리스트 요청하기 성공',
  GET_USER_DETAIL_CART_LIST_REQUEST_ERROR: '장바구니 리스트 요청하기 실패',

  /**
   * [유저] 장바구니 타임라인 리스트 요청하기
   */
  GET_USER_DETAIL_CART_LOG_LIST_REQUEST_SUCCESS: '장바구니 타임라인 리스트 요청하기 성공',
  GET_USER_DETAIL_CART_LOG_LIST_REQUEST_ERROR: '장바구니 타임라인 리스트 요청하기 실패',

  /**
   * [유저] 1:1 문의 내역 리스트 요청하기
   */
  GET_USER_DETAIL_CS_INQUIRY_LIST_REQUEST_SUCCESS: '1:1 문의 내역 리스트 요청하기 성공',
  GET_USER_DETAIL_CS_INQUIRY_LIST_REQUEST_ERROR: '1:1 문의 내역 리스트 요청하기 실패',

  /**
   * [유저] 1:1 문의 내역 리스트 엑셀 다운로드 요청하기
   */
  GET_USER_DETAIL_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '1:1 문의 내역 리스트 엑셀 다운로드 요청하기 성공',
  GET_USER_DETAIL_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '1:1 문의 내역 리스트 엑셀 다운로드 요청하기 실패',

  /**
   * [유저] 상품 문의 내역 리스트 요청하기
   */
  GET_USER_DETAIL_CS_QNA_LIST_REQUEST_SUCCESS: '상품 문의 내역 리스트 요청하기 성공',
  GET_USER_DETAIL_CS_QNA_LIST_REQUEST_ERROR: '상품 문의 내역 리스트 요청하기 실패',

  /**
   * [유저] 상품 문의 내역 리스트 엑셀 다운로드 요청하기
   */
  GET_USER_DETAIL_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 문의 내역 리스트 엑셀 다운로드 요청하기 성공',
  GET_USER_DETAIL_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 문의 내역 리스트 엑셀 다운로드 요청하기 실패',

  /**
   * [유저] 상품 후기 리스트 요청하기
   */
  GET_USER_DETAIL_CS_REVIEW_LIST_REQUEST_SUCCESS: '상품 후기 리스트 요청하기 성공',
  GET_USER_DETAIL_CS_REVIEW_LIST_REQUEST_ERROR: '상품 후기 리스트 요청하기 실패',

  /**
   * [유저] 상품 후기 리스트 엑셀 다운로드 요청하기
   */
  GET_USER_DETAIL_CS_REVIEW_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 후기 리스트 엑셀 다운로드 요청하기 성공',
  GET_USER_DETAIL_CS_REVIEW_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 후기 리스트 엑셀 다운로드 요청하기 실패',

  /**
   * [유저] 팔로우 태그 리스트 요청하기
   */
  GET_USER_DETAIL_TAG_LIST_REQUEST_SUCCESS: '팔로우 태그 리스트 요청하기 성공',
  GET_USER_DETAIL_TAG_LIST_REQUEST_ERROR: '팔로우 태그 리스트 요청하기 실패',

  /**
   * [유저] 태그 타임라인 리스트 요청하기
   */
  GET_USER_DETAIL_TAG_LOG_LIST_REQUEST_SUCCESS: '태그 타임라인 리스트 요청하기 성공',
  GET_USER_DETAIL_TAG_LOG_LIST_REQUEST_ERROR: '태그 타임라인 리스트 요청하기 실패',

  /**
   * [유저] 좋아요한 상품 리스트 요청하기
   */
  GET_USER_DETAIL_LIKE_PRODUCT_LIST_REQUEST_SUCCESS: '좋아요한 상품 리스트 요청하기 성공',
  GET_USER_DETAIL_LIKE_PRODUCT_LIST_REQUEST_ERROR: '좋아요한 상품 리스트 요청하기 실패',

  /**
   * [유저] 상품 좋아요 타임라인 리스트 요청하기
   */
  GET_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_REQUEST_SUCCESS: '상품 좋아요 타임라인 리스트 요청하기 성공',
  GET_USER_DETAIL_LIKE_PRODUCT_LOG_LIST_REQUEST_ERROR: '상품 좋아요 타임라인 리스트 요청하기 실패',

  /**
   * [유저] 좋아요한 브랜드 리스트 요청하기
   */
  GET_USER_DETAIL_LIKE_BRAND_LIST_REQUEST_SUCCESS: '좋아요한 브랜드 리스트 요청하기 성공',
  GET_USER_DETAIL_LIKE_BRAND_LIST_REQUEST_ERROR: '좋아요한 브랜드 리스트 요청하기 실패',

  /**
   * [유저] 브랜드 좋아요 타임라인 리스트 요청하기
   */
  GET_USER_DETAIL_LIKE_BRAND_LOG_LIST_REQUEST_SUCCESS: '브랜드 좋아요 타임라인 리스트 요청하기 성공',
  GET_USER_DETAIL_LIKE_BRAND_LOG_LIST_REQUEST_ERROR: '브랜드 좋아요 타임라인 리스트 요청하기 실패',

  /**
   *  [유저] 유저 포인트 내역 요청하기
   */
  GET_USER_DETAIL_POINT_LIST_REQUEST_SUCCESS: '유저 포인트 내역 요청하기 성공',
  GET_USER_DETAIL_POINT_LIST_REQUEST_ERROR: '유저 포인트 내역 요청하기 실패',

  /**
   *  [유저] 유저 디바이스 타임라인 리스트 요청하기
   */
  GET_USER_DETAIL_VISITOR_LOG_LIST_REQUEST_SUCCESS: '유저 디바이스 타임라인 리스트 요청하기 성공',
  GET_USER_DETAIL_VISITOR_LOG_LIST_REQUEST_ERROR: '유저 디바이스 타임라인 리스트 요청하기 실패',

  /**
   *  [유저] 유저 주문 리스트 요청하기
   */
  GET_USER_DETAIL_ORDER_LIST_REQUEST_SUCCESS: '유저 주문 리스트 요청하기 성공',
  GET_USER_DETAIL_ORDER_LIST_REQUEST_ERROR: '유저 주문 리스트 요청하기 요청하기 실패',

  /**
   *  [유저] 유저 쿠폰 리스트 요청하기
   */
  GET_USER_DETAIL_COUPON_LIST_REQUEST_SUCCESS: '유저 쿠폰 리스트 요청하기 성공',
  GET_USER_DETAIL_COUPON_LIST_REQUEST_ERROR: '유저 쿠폰 리스트 요청하기 실패',

  /**
   *  [유저] 유저 정보 편집 요청하기
   */
  EDIT_USER_DETAIL_REQUEST_SUCCESS: '유저 정보 편집 요청하기 성공',
  EDIT_USER_DETAIL_REQUEST_ERROR: '유저 정보 편집 요청하기 실패',

  /**
   *  [유저] 유저 등급 요약 정보 요청하기
   */
  GET_USER_DETAIL_GRADE_SUMMARY_REQUEST_SUCCESS: '유저 등급 요약 정보 요청하기 성공',
  GET_USER_DETAIL_GRADE_SUMMARY_REQUEST_ERROR: '유저 등급 요약 정보 요청하기 실패',

  /**
   *  [유저] 유저 등급 리스트 정보 요청하기
   */
  GET_USER_DETAIL_GRADES_REQUEST_SUCCESS: '유저 등급 요약 리스트 정보 요청하기 성공',
  GET_USER_DETAIL_GRADES_REQUEST_ERROR: '유저 등급 요약 리스트 정보 요청하기 실패',

  /**
   *  [유저] 유저 등급 정보 요청 성공
   */
  GET_USER_DETAIL_GRADE_INFO_REQUEST_SUCCESS: '유저 등급 정보 요청하기 성공',
  GET_USER_DETAIL_GRADE_INFO_REQUEST_ERROR: '유저 등급 정보 요청하기 실패',

  /**
   *  [유저] 유저 등급 히스토리 정보 요청하기
   */
  GET_USER_DETAIL_GRADE_HISTORY_REQUEST_SUCCESS: '유저 등급 히스토리 정보 요청하기 성공',
  GET_USER_DETAIL_GRADE_HISTORY_REQUEST_ERROR: '유저 등급 히스토리 정보 요청하기 실패',
};

export default accountUserToastMsg;
